module.exports = __webpack_public_path__ + "img/cirno_sc2.f90cb64b.png";